import { useQuery } from '@tanstack/react-query';
import { getTeamProps } from '../api';

function pct(v: number): string {
  if (!Number.isFinite(v)) return '—';
  if (v < 0.001) return '<0.1%';
  return `${(v * 100).toFixed(1)}%`;
}

export default function TeamPropsPanel({ code }: { code: string }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['team-props', code],
    queryFn: () => getTeamProps(code),
    refetchInterval: 5 * 60_000,
  });
  if (isLoading) return <section className="card p-4 text-xs text-dim">Loading tournament props…</section>;
  if (error || !data?.props) return null;
  const p = data.props;

  const rows: { label: string; value: number }[] = [
    { label: `Win Group ${p.groupLabel ?? ''}`, value: p.groupWinChance },
    { label: 'Advance to R32', value: p.advanceR32 },
    { label: 'Reach R16', value: p.reachR16 },
    { label: 'Reach QF', value: p.reachQF },
    { label: 'Reach SF', value: p.semiChance },
    { label: 'Reach Final', value: p.finalChance },
    { label: 'Win Cup', value: p.cupChance },
  ];

  return (
    <section className="card p-4">
      <div className="flex items-baseline justify-between mb-2">
        <h2 className="text-xs uppercase tracking-widest text-dim">Tournament props</h2>
        <span className="text-[10px] text-dim">Monte Carlo · strength {p.strength.toFixed(2)}</span>
      </div>
      <div className="space-y-1.5">
        {rows.map((r, i) => (
          <div key={i} className="flex items-center gap-2 text-sm">
            <span className="w-32 sm:w-40 truncate text-dim">{r.label}</span>
            <div className="flex-1 h-1.5 rounded-full bg-ink-800 overflow-hidden">
              <div className="h-full bg-cyan-500/70 rounded-full" style={{ width: `${Math.min(100, r.value * 100)}%` }} />
            </div>
            <span className="stat w-12 text-right text-cyan-400">{pct(r.value)}</span>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-dim mt-2">1,500-iteration Monte Carlo simulation using current team strengths (actual + expected group pts). Updates ~every 5 min.</p>
    </section>
  );
}
